
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g91erRSoJLwSHX_lySCvMteXn4ALg7pQW1BJsQwWJckIMeta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexr0KiO6Ilw_45_45V9ACgEYoSbkD434_451_45to35QhHjKWv5p4Meta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchy8Y0EN_Fv7b_byFuh_i_4M4S3uoFOjFXeSdsUzRP0O4Meta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexjfd68bgPK9f6byDFlIM3eiJ56_s_ziYtTPtwZYrQK2YMeta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93sC3sqfbVaCnI6NEY8VtPYxt50PtNwp6oRkQoW3WGOT8Meta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexNzzfx560a1MBLKF1KjojmhUm2HHyT0QbWM701Th2smkMeta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93vOxuNIJnn2luJVwr2Amge3gPgUZjsE_45_45FyIymLLRM2YMeta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexxjUyMWSWG0GSyZ_45Duo0livXQA2ATY5KulkQW9XcLfUsMeta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_937cZIZECiV0BrUhRYy6Zs7u3ezCYm_pAi7_45ZJ9I8zUKMMeta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index69dTprckQawh_45NDPk3NBBIzf77Zr0CnB0nJiXldtOCsMeta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexTRsGehgf2ZK_45EXvmq5oQwG5lnM4O6BEcTj6DVm9CK_45sMeta } from "/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexNzzfx560a1MBLKF1KjojmhUm2HHyT0QbWM701Th2smkMeta || {},
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexxjUyMWSWG0GSyZ_45Duo0livXQA2ATY5KulkQW9XcLfUsMeta || {},
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index69dTprckQawh_45NDPk3NBBIzf77Zr0CnB0nJiXldtOCsMeta || {},
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexTRsGehgf2ZK_45EXvmq5oQwG5lnM4O6BEcTj6DVm9CK_45sMeta || {},
    component: () => import("/codebuild/output/src1914483924/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]